<script setup>
import { onMounted } from "vue";
import FooterBar from "@/components/FooterBar.vue";
import NavBar from "@/components/NavBar.vue";
import TermsAndConditions from "@/components/TermsAndConditions.vue";
import { useI18n } from "vue-i18n";
const { t } = useI18n();

onMounted(() => {
  document.title = t('meta.title');
  let metaDescription = document.querySelector('meta[name="description"]');
  if (!metaDescription) {
    metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    document.head.appendChild(metaDescription);
  }
  metaDescription.content = t('meta.description');

  let canonicalLink = document.querySelector('link[rel="canonical"]');
  if (!canonicalLink) {
    canonicalLink = document.createElement('link');
    canonicalLink.rel = 'canonical';
    document.head.appendChild(canonicalLink);
  }
  canonicalLink.href = window.location.href;
});

</script>

<template>
  <NavBar/>
  <TermsAndConditions/>
  <FooterBar/>
</template>


<style>
@font-face {
  font-family: JETSansVF2;
  src: url("assets/fonts/JETSansVF2-Merged.woff2") format("woff2"),
    url("assets/fonts/JETSansVF2-Merged.woff") format("woff");
  font-display: swap;
}

body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

p {
  font-family: "JETSansVF2", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: #242E30;
  text-wrap: pretty;
}

h1{
  font-family: "JETSansVF2", sans-serif;
  text-align: center;
  font-size: 36px;
  line-height: 36px;
  color: #fff;
}

h2 {
  font-family: "JETSansVF2", sans-serif;
  font-size: 21px;
  font-weight: 300;
  line-height: 24px;
  color: #242f30;
}
</style>
